/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from 'components';
import './Step.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import IconCompleted from 'assets/icons/complete-status.svg';
import IconIncomplete from 'assets/icons/incomplete-icon.svg';


const Step = ({
  id, isActive, isCompleted, isContinue, onStepClick, isAllCompleted,
  currentStep, intl,
  // level, title,
  // isTranslate,
}) => {
  const classes = classnames({
    step: true,
    'step--active': isActive,
    'step--completed': isCompleted,
  });

  return (
    <div className={classes} id={id}>

      <section>
        <small className="step__level">
          {/* {isTranslate ? <FormattedMessage id={level} /> : level} */}
          <FormattedMessage id={id} />
        </small>
        {/* <h3 className="step__title">{isTranslate ? <FormattedMessage id={title} /> : title}</h3> */}
        <h3 className="step__title"><FormattedMessage id={`${id}.title`} /></h3>

        { isActive && !isContinue ? <Button onButtonClick={onStepClick} value={(<FormattedMessage id="step.startNow" />)} isSecondary isSmall /> : null}

        {!isActive && !isContinue && !isCompleted && id === 'step3' && currentStep.substr(4, 1) >= 3 && (
          <>
            <small style={{ color: 'red' }}>Missing mandatory field(s).</small>
            <Button onButtonClick={onStepClick} value={(<FormattedMessage id="step.edit" />)} isSmall isLink />
            <img className="step__icon" src={IconIncomplete} alt="Incompleted" />
          </>
        )}

        { !isCompleted && isActive && isContinue && (
        <>
          <small>{intl.formatMessage({ id: 'almostDone' })}</small>
          <Button onButtonClick={onStepClick} value={(<FormattedMessage id="step.continue" />)} isSecondary isSmall />
          <img className="step__icon" src={IconIncomplete} alt="Incompleted" />
        </>
        )}

        { isCompleted && !isActive && (
        <>
          {!isAllCompleted ? <Button onButtonClick={onStepClick} value={(<FormattedMessage id="step.edit" />)} isSmall isLink />
            : id === 'step6' ? <Button onButtonClick={onStepClick} value={(<FormattedMessage id="step.view" />)} isSmall isLink /> : <span className="spacer" />}
          <img className="step__icon" src={IconCompleted} alt="Completed" />
        </>
        )}
      </section>
    </div>
  );
};

Step.propTypes = {
  /** step id */
  id: PropTypes.string,
  // /** Step level e.g. Step 1 */
  // level: PropTypes.string,
  // /** Step Title */
  // title: PropTypes.string,
  // /** translate text? */
  // isTranslate: PropTypes.bool,
  /** is step completed */
  isCompleted: PropTypes.bool,
  /** is step active */
  isActive: PropTypes.bool,
  /** Continue step? */
  isContinue: PropTypes.bool,
  /** on event click */
  onStepClick: PropTypes.func,
};

Step.defaultProps = {
  id: null,
  // level: 'Step 1',
  // title: 'Phone Number Verification',
  // isTranslate: true,
  isCompleted: false,
  isActive: false,
  isContinue: false,
  onStepClick: () => {},
};

export default injectIntl(Step);
